import React from 'react';
export class ModalComponent extends React.Component {
}



// WEBPACK FOOTER //
// ./components/modal/PropsType.tsx